import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { CircularProgress, TextField, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { injectIntl } from 'react-intl';
import AutomationActionSendProviderMessage from '../../../../../components/automation/AutomationActionSendProviderMessage';

const WHATSAPP_PROVIDER_ID = 2;

const emptyConfig = (registrationNumberRequestId) => ({
  messageproviderid: WHATSAPP_PROVIDER_ID,
  registrationnumberrequestid: registrationNumberRequestId || 0,
  templatemessageid: 0,
  parametersmappingjson: { header: {}, body: {}, button: {} },
  recipientsjson: { includeRequester: false, includeAssigned: false, includeObservant: false, phones: [] },
});

// Modal de ENVIO DE MENSAGEM ATIVA (WhatsApp) a partir da conversa. REUSA o componente de template
// da automação em modo `directSend` (provedor/número fixos = os da conversa, variáveis literais, sem
// a seção de destinatários do chamado — o destino aqui é o contato da conversa). No confirmar, emite o
// payload do endpoint desacoplado dispatch-active-message (mesma lógica de optin/strategy da automação).
function DialogActiveMessage(props) {
  const intl = props.intl;

  // Estado LOCAL (perf): o componente de template altera muito; manter aqui evita re-render do omnichannel.
  const [messageConfig, setMessageConfig] = useState(emptyConfig(props.registrationNumberRequestId));
  const [error, setError] = useState(false);

  useEffect(() => {
    if (props.open) {
      setMessageConfig(emptyConfig(props.registrationNumberRequestId));
      setError(false);
    }
  }, [props.open, props.registrationNumberRequestId]);

  const confirm = () => {
    const cfg = messageConfig || {};
    if (!cfg.templatemessageid) { setError(true); return; }
    const mapping = cfg.parametersmappingjson || {};
    // Payload do dispatch-active-message: recipient ÚNICO = o contato da conversa.
    const payload = {
      registrationNumberRequestId: cfg.registrationnumberrequestid,
      templateMessageId: cfg.templatemessageid,
      recipients: [{
        phoneNumber: props.customerPhone,
        userId: props.customerUserId || null,
        label: 'conversa',
      }],
      headerVariableValues: mapping.header || {},
      bodyVariableValues: mapping.body || {},
      buttonVariableValues: mapping.button || {},
      recipientUserIdReference: props.customerUserId || null,
    };
    props.onConfirm(payload);
  };

  return (
    <Dialog
      open={props.open}
      aria-labelledby="active-message-dialog-title"
      maxWidth="md"
      fullWidth
      PaperProps={{ sx: { maxHeight: '90vh', borderRadius: '12px' } }}
    >
      <DialogTitle id="active-message-dialog-title">
        <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
          <WhatsAppIcon sx={{ color: '#25D366' }} />
          {intl.formatMessage({ id: 'active.message.modal.title' })}
        </span>
      </DialogTitle>
      <DialogContent>
        <div style={{ overflowY: 'auto', maxHeight: '74vh', paddingRight: '8px' }}>
          <DialogContentText sx={{ mb: 2 }}>
            {intl.formatMessage({ id: 'active.message.modal.subtitle' })}
          </DialogContentText>

          <TextField
            fullWidth
            variant="outlined"
            size="small"
            label={intl.formatMessage({ id: 'active.message.destination' })}
            value={props.customerPhone || ''}
            InputProps={{ readOnly: true }}
            InputLabelProps={{ shrink: true }}
            sx={{ mb: 2 }}
          />

          {/* Componente da automação reusado: directSend esconde provedor/número/destinatários e usa
              variáveis literais; ele carrega os templates do número fixo, faz preview e os inputs. */}
          <AutomationActionSendProviderMessage
            value={messageConfig}
            onChange={(updated) => setMessageConfig(updated)}
            hirerId={props.hirerId}
            directSend
            fixedProviderId={WHATSAPP_PROVIDER_ID}
            fixedRegistrationNumberRequestId={props.registrationNumberRequestId}
            literalVariables
            error={error}
          />

          {error && !messageConfig?.templatemessageid && (
            <Typography style={{ fontSize: 12, color: '#d32f2f', marginTop: 8 }}>
              {intl.formatMessage({ id: 'active.message.select.template' })}
            </Typography>
          )}
        </div>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.onClose()} color="primary" disabled={props.loading}>
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button
          onClick={confirm}
          variant="contained"
          color="primary"
          disabled={props.loading}
          startIcon={props.loading ? <CircularProgress size={16} color="inherit" /> : <WhatsAppIcon />}
        >
          {intl.formatMessage({ id: 'active.message.send' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default injectIntl(DialogActiveMessage);
